import { render } from "./Predmeti.vue?vue&type=template&id=49aa73fb&scoped=true"
import script from "./Predmeti.vue?vue&type=script&lang=js"
export * from "./Predmeti.vue?vue&type=script&lang=js"

import "./Predmeti.vue?vue&type=style&index=0&id=49aa73fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aa73fb"]])

export default __exports__